var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm.srcList && _vm.srcList.length > 1
      ? _c("div", { staticClass: "tips" }, [_vm._v("点击图片查看更多")])
      : _vm._e(),
    _c("img", {
      staticStyle: { width: "200px", cursor: "pointer" },
      attrs: { src: _vm.srcList[0] },
      on: {
        click: function ($event) {
          return _vm.showImg(0)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }